<template>
	<div class="action-flow-node action-flow-node-call" style="height: 200px;">
		<div class="action-flow-title">Call n8n Webhook</div>
		<div class="action-flow-hint">Send a webhook message to start an n8n workflow.</div>
		
		<ActionParamHint label="Webhook URL" hint="URL of the n8n webhook to call. Authentication is handled automatically by Bearer Auth." param-class="param-config"
			param-input-type="text"  param-input-label="URL" @param-change="handleParamChange"
			:param-input-value="parameters.url"
		/>
		<ActionParamHint label="Data" hint="Data to send to the n8n workflow. You can feed in more than one object to this input." param-class="param-tgt"
			param-input-type="textarea"  param-input-label="Data" @param-change="handleParamChange"
			:param-input-value="parameters.data"
		/>
		<ActionParamHint label="Webhook Return" hint="Flow continues when webhook message is sent and responds. Data may or may not be available." param-class="param-src" />
		
		<Handle type="target" id="tgt-data" :position="Position.Left" style="top: 135px;" />
		<Handle type="source" id="src-return" :position="Position.Right" style="top: 175px;" />
	</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
	url: '',
	data: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			url: newNodeData.data?.url || '',
			data: newNodeData.data?.data || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	switch (paramData.label.toLowerCase()) {
		case 'webhook url':
			parameters.value.url = paramData.value;
			break;
		case 'data':
			parameters.value.data = paramData.value;
			break;
		default:
			console.error(`Unknown parameter label: ${paramData.label}`);
			return;
	}
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

</script>
	